export const MAPBOX_API = {
  url: process.env.REACT_APP_MAPBOX_API,
  public_token: process.env.REACT_APP_MAPBOX_PUBLIC_TOKEN,
  access_token: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
};

export const GOOGLE_API = {
  maps_api_key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
}

export const SALES_RUSH_API = process.env.REACT_APP_SALES_RUSH_API;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const STRIPE = {
  client_secret: process.env.REACT_APP_STRIPE_CLIENT_SECRET,
  monthly_id: process.env.REACT_APP_STRIPE_PLAN_MONTHLY,
  yearly_id: process.env.REACT_APP_STRIPE_PLAN_YEARLY,
}

export const RADAR = {
  api_key: process.env.REACT_APP_RADAR_API_KEY
}

export const APP_CONFIG = {
  app_main_domain: process.env.REACT_APP_MAIN_DOMAIN,
  sales_rush_landing_page: process.env.REACT_APP_SALES_RUSH_LANDING_PAGE,
}

export const TYPESENSE_CONFIG = {
  host: process.env.REACT_APP_TYPESENSE_HOST,
  api_key: process.env.REACT_APP_TYPESENSE_API_KEY,
}

export const PUSH_NOTIFICATIONS_API = {
  api: process.env.REACT_APP_PUSH_NOTIFICATIONS_API,
}

export const WEBFINDER = {
  domain: process.env.REACT_APP_WEBFINDER,
  protocol: process.env.REACT_APP_WEBFINDER_PROTOCOL,
}

export const SYSTEM_FIELDS_NAME_IDS = [
  process.env.REACT_APP_SYSTEM_FIELD_LEAD_NAME_ID,
  process.env.REACT_APP_SYSTEM_FIELD_COMPANY_NAME_ID,
  process.env.REACT_APP_SYSTEM_FIELD_OPPORTUNITY_NAME_ID,
  process.env.REACT_APP_SYSTEM_FIELD_FIRST_NAME_ID,
  process.env.REACT_APP_SYSTEM_FIELD_LAST_NAME_ID,
  process.env.REACT_APP_SYSTEM_FIELD_MARKETING_TARGET_NAME_ID,
];
